import { NavLink } from 'react-router-dom';

function Common(props) {
    return (
      <>
         <section id="header" className="d-flex align-items-center">
         <div className="container-fluid">
      <div className="row">
        <div className="col-10 mx-auto">
          <div className='row'>
            <div className="col-md-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex justify-content-center flex-column">
              <h2>{props.tagLine} <strong className="brand-name"> Muhammad Anas</strong></h2>
              <h3 className="my-3">
                Talented React developer for making websites
              </h3>
              <p style={{fontSize:'16px', fontWeight:'bold'}}>{props.discription}</p>
              <div className="mt-3">
                <NavLink to={props.visit}><button className="btn-gs">{props.btnName}</button></NavLink>
              </div>
            </div>    
            <div className="col-lg-6 order-1 order-lg-2 header-img"> 
                <img src={props.imgSrc} className="img-fluid animated mt-4 home_img" alt="Home img"/>
            </div>
            </div>
        </div>
      </div>
    </div>
         </section>
      </>
    );
  }
  
  export default Common;
  